import React from 'react';
import { Button } from '@chakra-ui/react';

export const FrostButton = ({ children, onClick, ...rest }) => {
    return (
        <Button
            {...rest}
            rounded={'full'}
            size={'lg'}
            fontWeight={'normal'}
            bg="mkyfive.50"
            color="mkytwo.500"
            colorScheme="mkytwo.500"
            border="2px"
            variant="outline"
            transform="transform 0.3s ease"
            cursor="pointer"
            _hover={{
                bg: 'mkytwo.500',
                color: 'mkyfive.50',
                boxShadow: 'dark-lg',
                _disabled: {
                    bg: 'mkyfive.50',
                    color: 'mkytwo.500',
                    boxShadow: 'none'
                },
            }}
            px={6}
            onClick={onClick}
        >
            {children}
        </Button>
    );
};
